// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__3ld4H","title":"AfterBackImages_title__1cfuZ","images":"AfterBackImages_images__2lE5m"};